module.exports = __webpack_public_path__ + "media/images/pro_exclusive_tablet-ef350505.svg";